import type { Label } from "@storytell/types";

export type LabelListScope = "my" | "all";

export function isAutoGeneratedLabelName(name: string): boolean {
  return (
    name.startsWith("Added on ") ||
    name.startsWith("Added by ") ||
    name.startsWith("Generated by Chief") ||
    name === "Generated by Chief" ||
    name.startsWith("Generated by Storytell") ||
    name === "Generated by Storytell"
  );
}

export function isUserCreatedLabel(label: Label): boolean {
  return !label.isSystem && !isAutoGeneratedLabelName(label.name);
}

function isLabelExcludedFromMyScope(label: Label): boolean {
  return !isUserCreatedLabel(label);
}

export function filterLabelsForScope(labels: Label[], scope: LabelListScope): Label[] {
  if (scope === "all") return labels;
  return labels.filter((label) => !isLabelExcludedFromMyScope(label));
}

/** True when the user is on "My Labels", has a search query, nothing matches "my", but the raw search has hits (under "All"). */
export function shouldAutoExpandScopeToAll(
  searchedLabels: Label[],
  currentScope: LabelListScope,
  searchQueryTrimmed: string
): boolean {
  if (searchQueryTrimmed === "") return false;
  if (currentScope !== "my") return false;
  if (filterLabelsForScope(searchedLabels, "my").length > 0) return false;
  return searchedLabels.length > 0;
}
